module.exports = __webpack_public_path__ + "img/fullver-introduction.797e1f0.png";